import template from './workflow-block.html';
import controller from './workflow-block.controller';
import './workflow-block.scss';

export default {
	template,
	controller,
	bindings: {
		widgetId: '<',
		isOpen: '=?',
	},
};
